export default "__VITE_ASSET__CUF2V5ae__"